module.exports = __webpack_public_path__ + "fonts/SofiaProMedium.d356bfed.woff";